const style = {
  divStyle: display => ({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
  }),
  containerStyle: (width, height, positionX, positionY) => ({
    width: `${width}px`,
    height: `${height}px`,
    position: 'absolute',
    left: `${positionX * 100}%`,
    top: `${positionY * 100}%`,
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
  }),
};

export default style;



// WEBPACK FOOTER //
// ./src/containers/MapEditor/MapContainer.styles.js